import { IconProps } from './IconProps';

export const FiveStarsGold = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="128px"
      height="22px"
      viewBox="0 0 128 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Combined Shape</title>
      <g
        id="Desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProducPage"
          transform="translate(-253.000000, -11785.000000)"
          fill="#FD9400"
          fillRule="nonzero"
        >
          <g id="Group-29" transform="translate(158.000000, 748.000000)">
            <g id="Group-32" transform="translate(0.000000, 3017.000000)">
              <g id="UserReview" transform="translate(0.000000, 7815.000000)">
                <g id="cta" transform="translate(0.000000, 168.000000)">
                  <g
                    id="Group-33-Copy"
                    transform="translate(0.000000, 0.000000)"
                  >
                    <path
                      d="M106.596674,37 L110.142209,44.2937114 L118.193612,45.402978 L112.333238,51.0200853 L113.763819,59 L106.596585,55.1774393 L99.4289107,59 L100.859493,51.0200853 L95,45.402978 L103.050521,44.2937114 L106.596674,37 Z M132.798271,37 L136.343806,44.2937114 L144.395209,45.402978 L138.534835,51.0200853 L139.965416,59 L132.798183,55.1774393 L125.630508,59 L127.06109,51.0200853 L121.201597,45.402978 L129.252118,44.2937114 L132.798271,37 Z M158.999868,37 L162.545403,44.2937114 L170.596806,45.402978 L164.736432,51.0200853 L166.167014,59 L158.99978,55.1774393 L151.832105,59 L153.262687,51.0200853 L147.403194,45.402978 L155.453716,44.2937114 L158.999868,37 Z M185.201465,37 L188.747,44.2937114 L196.798403,45.402978 L190.938029,51.0200853 L192.368611,59 L185.201377,55.1774393 L178.033702,59 L179.464284,51.0200853 L173.604791,45.402978 L181.655313,44.2937114 L185.201465,37 Z M211.403062,37 L214.948597,44.2937114 L223,45.402978 L217.139626,51.0200853 L218.570208,59 L211.402974,55.1774393 L204.235299,59 L205.665881,51.0200853 L199.806388,45.402978 L207.85691,44.2937114 L211.403062,37 Z"
                      id="Combined-Shape"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

